// src/hooks/useIsMobile.js
//
// Single-purpose breakpoint hook.
// Mobile only for now (tablet breakpoint will be added later per project plan).

import { useState, useEffect } from 'react';

export default function useIsMobile(breakpoint = 768) {
  const getMatch = () =>
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    const onResize = () => setIsMobile(getMatch());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return isMobile;
}